import type { CheckState } from "@/services/adminModelCurrency";
import { cn } from "@/lib/utils";
import ProviderStatusLine from "./ProviderStatusLine";
import { formatDateTime } from "../programNews/formatters";

const STATUS_WORDS: Record<string, string> = {
  ok: "finished fine",
  error: "failed",
  failed: "failed",
};

/** The most recent automatic check: when, how it went, what it found. */
const LastCheckLine = ({ state }: { state: CheckState }) => {
  if (!state.lastRunAt) {
    return <p className="text-sm text-muted-foreground">No check has run yet.</p>;
  }
  const status = state.lastRunStatus
    ? (STATUS_WORDS[state.lastRunStatus] ?? state.lastRunStatus)
    : null;
  const healthy = state.lastRunStatus === "ok" && !state.lastError;
  const counts = state.counts;
  return (
    <div className="min-w-0 space-y-1 text-sm">
      <p className="flex flex-wrap items-center gap-x-2 font-medium">
        <span
          className={cn(
            "h-2 w-2 shrink-0 rounded-full",
            healthy ? "bg-emerald-500" : "bg-amber-500"
          )}
          aria-hidden="true"
        />
        Last check {formatDateTime(state.lastRunAt)}
        {status ? <span className="font-normal text-muted-foreground">· {status}</span> : null}
      </p>
      {counts ? (
        <p className="text-muted-foreground">
          Found {counts.candidates} new model{counts.candidates === 1 ? "" : "s"},{" "}
          {counts.deprecations} retiring, {counts.missing} missing, {counts.unpriced} without a
          price.
        </p>
      ) : null}
      <ProviderStatusLine providers={state.providers} prices={state.prices} />
      {state.lastError ? (
        <p role="alert" className="text-destructive">
          Last error: {state.lastError}
        </p>
      ) : null}
    </div>
  );
};

export default LastCheckLine;
